module.exports = __webpack_public_path__ + "static/img/banner1.61b46885.png";